var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Modal', {
    attrs: {
      "modalVisible": _vm.modal,
      "width": "600px",
      "id": "cancel-order-modal"
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "text-left text-black",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-4"
  }, [_c('div', [_vm.step === 'reason' ? _c('p', {
    staticClass: "text-3xl font-extrabold"
  }, [_vm._v(" Batalkan Pesanan? ")]) : _c('p', {
    staticClass: "text-3xl font-extrabold"
  }, [_vm._v("Konfirmasi Pembatalan")])])]), _vm.step === 'reason' ? _c('div', [_c('p', {
    staticClass: "text-xl font-bold mb-4"
  }, [_vm._v("Alasan Pembatalan")]), _c('div', {
    staticClass: "flex flex-col items-start gap-4 text-black"
  }, [_vm._l(_vm.reasons, function (r, idx) {
    return _c('label', {
      key: idx,
      staticClass: "flex items-center gap-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedReason,
        expression: "selectedReason"
      }],
      attrs: {
        "type": "radio",
        "name": "cancelReason",
        "id": 'reason' + idx
      },
      domProps: {
        "value": r.value,
        "checked": _vm._q(_vm.selectedReason, r.value)
      },
      on: {
        "change": function ($event) {
          _vm.selectedReason = r.value;
        }
      }
    }), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.label)
      }
    })]);
  }), _vm.selectedReason === 'other' ? _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otherReason,
      expression: "otherReason"
    }],
    staticClass: "border border-gray-400 rounded-lg p-2",
    attrs: {
      "name": "otherReason",
      "cols": "60",
      "rows": "5",
      "placeholder": "Tulis alasan tambahan..."
    },
    domProps: {
      "value": _vm.otherReason
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otherReason = $event.target.value;
      }
    }
  })]) : _vm._e(), _c('div', {}, [_c('p', {
    staticClass: "font-semibold mb-2 text-lg"
  }, [_vm._v("Call Function")]), _c('label', {
    staticClass: "flex items-center gap-2 mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.callFunction.database,
      expression: "callFunction.database"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.callFunction.database) ? _vm._i(_vm.callFunction.database, null) > -1 : _vm.callFunction.database
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.callFunction.database,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.callFunction, "database", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.callFunction, "database", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.callFunction, "database", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Database")])]), _c('label', {
    staticClass: "flex items-center gap-2 mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.callFunction.third_party,
      expression: "callFunction.third_party"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.callFunction.third_party) ? _vm._i(_vm.callFunction.third_party, null) > -1 : _vm.callFunction.third_party
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.callFunction.third_party,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.callFunction, "third_party", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.callFunction, "third_party", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.callFunction, "third_party", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Third Party")])]), _c('label', {
    staticClass: "flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.callFunction.payment_gateway,
      expression: "callFunction.payment_gateway"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.callFunction.payment_gateway) ? _vm._i(_vm.callFunction.payment_gateway, null) > -1 : _vm.callFunction.payment_gateway
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.callFunction.payment_gateway,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.callFunction, "payment_gateway", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.callFunction, "payment_gateway", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.callFunction, "payment_gateway", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Payment Gateway")])])]), _c('div', {
    staticClass: "flex justify-center w-full gap-6 mt-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "error",
      "size": "full"
    },
    on: {
      "action": _vm.handleClose
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Lanjutkan Pembatalan",
      "type": "delete",
      "size": "full",
      "disabled": !_vm.canProceedToTerms
    },
    on: {
      "action": _vm.goToTerms
    }
  })], 1)], 2)]) : _vm.step === 'terms' ? _c('div', [_c('p', {
    staticClass: "text-xl font-bold mb-4"
  }, [_vm._v("Syarat & Ketentuan Pembatalan")]), _c('div', {
    staticClass: "text-sm text-neutral-700 leading-relaxed max-h-56 overflow-auto mb-4"
  }, [_c('ol', {
    staticClass: "list-decimal list-outside ml-5"
  }, [_c('li', [_vm._v(" Pengajuan pembatalan hanya bisa dilakukan dalam waktu maksimal 30 menit setelah pembayaran. ")]), _c('li', [_vm._v(" Pembatalan akan diproses jika pihak ekspedisi menyetujui permintaan pembatalan. ")]), _c('li', [_vm._v(" Pengembalian dana (refund) akan diproses sesuai metode pembayaran yang digunakan. "), _c('br'), _vm._v("Qris by GoPay (on-us) — Pembayaran melalui aplikasi gopay diproses 1 x 24 jam setelah Pengajuan. "), _c('br'), _vm._v("Qris by GoPay (off-us) — Pembayaran menggunakan e-wallet / bank lain diproses 15–20 hari kerja. ")])])]), _c('hr', {
    staticClass: "mb-4 mt-4"
  }), _c('div', [_c('label', {
    staticClass: "inline-flex items-center gap-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.acceptedTerms,
      expression: "acceptedTerms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptedTerms) ? _vm._i(_vm.acceptedTerms, null) > -1 : _vm.acceptedTerms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.acceptedTerms,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.acceptedTerms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.acceptedTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.acceptedTerms = $$c;
        }
      }
    }
  }), _c('span', [_vm._v("Saya telah membaca dan setuju dengan syarat & ketentuan pembatalan pesanan ini.")])]), _c('div', {
    staticClass: "text-sm text-muted mt-4 mb-2 text-gray-400"
  }, [_vm._v(" Dengan melanjutkan, pembatalan akan diproses sesuai kebijakan yang tercantum di atas. ")])]), _c('div', {
    staticClass: "flex justify-center w-full gap-4 mt-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Kembali",
      "type": "secondary",
      "size": "full"
    },
    on: {
      "action": _vm.backToReasons
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Batalkan Pesanan",
      "type": "delete",
      "disabled": !_vm.acceptedTerms || _vm.loading,
      "size": "full"
    },
    on: {
      "action": _vm.confirmCancel
    }
  })], 1)]) : _vm.step === 'loading' ? _c('div', {
    staticClass: "text-center py-12"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Memproses pembatalan...")])]) : _vm._e()])]), _c('CancelOrderSuccessModal', {
    attrs: {
      "modal": _vm.visibleModalCancelOrderSuccess
    },
    on: {
      "toggle": _vm.toggleModalSuccessCancelOrder
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }